import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import {
  PASSWORD_MIN_LENGTH,
  PASSWORD_MAX_LENGTH,
  PasswordStrengthDetails,
} from '../../utils/validators.validator';

/**
 * Presentational password-requirements checklist.
 */
@Component({
  selector: 'app-password-criteria',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './password-criteria.component.html',
  styleUrls: ['./password-criteria.component.scss'],
})
export class PasswordCriteriaComponent {
  /** The `details` from `ctrl.errors?.details`; */
  @Input() details?: PasswordStrengthDetails;

  /** Controls the smooth expand/collapse of the checklist. */
  @Input() expanded = false;

  PASSWORD_MIN_LENGTH = PASSWORD_MIN_LENGTH;
  PASSWORD_MAX_LENGTH = PASSWORD_MAX_LENGTH;
}
